// extracted by mini-css-extract-plugin
export default {"ButtonContainer":"property_ButtonContainer__4Uox1"};